import { useEffect, useRef, useState } from 'react'
import { urlApi } from '../../config'
import { getAccessToken } from '../../auth'

// Trae el detalle (con fotos de conductor y pasajeros) de los viajes en vivo.
// El listado /admin/lobbies no incluye fotos, así que las completamos por id,
// con caché (no refetch) y un pool de concurrencia acotado para no inundar la API.
const CONCURRENCY = 4

export default function useLobbyDetails(ids) {
  const [details, setDetails] = useState({})
  const cacheRef = useRef({}) // id -> 'pending' | detail | null(fallo, reintenta luego)

  const key = ids.filter(Boolean).join(',')

  useEffect(() => {
    let alive = true
    const toFetch = ids.filter(id => id && !cacheRef.current[id])
    if (!toFetch.length) return
    toFetch.forEach(id => {
      cacheRef.current[id] = 'pending'
    })

    const run = async () => {
      const token = await getAccessToken()
      const headers = { ...(typeof token === 'string' && { Authorization: `Bearer ${token}` }) }
      const queue = [...toFetch]
      const worker = async () => {
        while (queue.length) {
          const id = queue.shift()
          try {
            const res = await fetch(`${urlApi}/admin/lobbies/${id}`, { credentials: 'include', headers })
            if (!res.ok) throw new Error('bad_status')
            const json = await res.json()
            cacheRef.current[id] = json
            if (alive) setDetails(d => ({ ...d, [id]: json }))
          } catch (e) {
            cacheRef.current[id] = null // permitir reintento en el próximo ciclo
          }
        }
      }
      await Promise.all(Array.from({ length: Math.min(CONCURRENCY, queue.length) }, worker))
    }
    run()

    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])

  return details
}
